import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const TRACTORATTACHMENTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TractorAttachmentType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const TRACTORATTACHMENTTYPE_CONFIG = {
  entityName: 'TractorAttachmentType',
  localizationKey: 'General::Entity.TractorAttachmentType',
  fields: TRACTORATTACHMENTTYPE_FIELDS,
  permission: 'GeneralMachinesAndVehicles.TractorAttachmentTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
